import { faPen } from '@fortawesome/free-solid-svg-icons'
import { customerAttrGlobalAssignEdit } from 'actions'
import TableWithSelection from 'components/abmUtils/TableWithSelection'
import CommonModal from 'components/common/commonModal'
import { customerAttributesGlobalUploadModalFields } from 'constants/crudsConfig/crudCustomerAttributesGlobalUpload/crudCustomerAttributesGlobalUploadModalForm'
import { ICrudGenericFields } from 'models/CrudInterface'
import { ICustomerAttributesGlobalUploadTableProps } from 'models/CustomerGlobalUploadInterface'
import { ITableWithSelectionFields } from 'models/TableWithSelection'
import React, { Component } from 'react'
import { Alert, Col } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import _ from 'underscore'
import CustomerAttributesGlobalModalForm from './CustomerAttributesGlobalModalForm'

class CustomerAttributesGlobalUploadTable extends Component<ICustomerAttributesGlobalUploadTableProps> {
	render() {
		const {
			t,
			tableFields,
			modalFields,
			handleModalSubmit,
			handleSelection,
			handleChangeTable,
			handleCloseEditPopup,
			handleOpen,
			selectedRows,
			fields,
			customerAttrEdit,
			showEditPopup
		} = this.props

		const newFieldsConfig = [...customerAttributesGlobalUploadModalFields]

		const data = fields
			? _.map(fields.lista, (item) => {
					const completeItem = {
						codigo: item.codigo,
						niclie: item.niclie,
						nro: item.nro,
						rsoc: item.rsoc,
						[item.listaAtribs[0].cod_atrib]: item.listaAtribs[0].valor_atrib,
						[item.listaAtribs[1].cod_atrib]: item.listaAtribs[1].valor_atrib,
						[item.listaAtribs[2].cod_atrib]: item.listaAtribs[2].valor_atrib,
						[item.listaAtribs[3].cod_atrib]: item.listaAtribs[3].valor_atrib,
						[item.listaAtribs[4].cod_atrib]: item.listaAtribs[4].valor_atrib
					}

					return completeItem
			  })
			: []

		const editData = {
			codigo: customerAttrEdit?.codigo,
			niclie: customerAttrEdit?.niclie,
			rsoc: customerAttrEdit?.rsoc,
			[customerAttrEdit?.lista[0]?.codigo]: customerAttrEdit?.lista[0]?.valor,
			[customerAttrEdit?.lista[1]?.codigo]: customerAttrEdit?.lista[1]?.valor,
			[customerAttrEdit?.lista[2]?.codigo]: customerAttrEdit?.lista[2]?.valor,
			[customerAttrEdit?.lista[3]?.codigo]: customerAttrEdit?.lista[3]?.valor,
			[customerAttrEdit?.lista[4]?.codigo]: customerAttrEdit?.lista[4]?.valor
		}

		let attrNumber = 0

		for (const key in editData) {
			if (!_.some(newFieldsConfig, (field) => field.id === key)) {
				const newFieldConfig: ICrudGenericFields = {
					id: key,
					type:
						customerAttrEdit?.lista[attrNumber]?.valores?.length > 0
							? 'combo'
							: 'text',
					labelWidth: 'col-sm-3',
					width: 'col-sm-8',
					height: 'col-sm-12',
					default: null,
					maxChars: 99,
					autoComplete: 'new-off',
					disabled: false,
					comboData: 'attribute' + attrNumber,
					dependsOn: {
						id: '',
						values: [
							{
								idValue: '',
								disabled: false
							}
						]
					}
				}
				newFieldsConfig.push(newFieldConfig)

				attrNumber++
			}
		}

		const editableModalFields = _.map(modalFields, (field) => {
			return field.agrupador === 'atributo'
				? {
						...field,
						editable: true
				  }
				: {
						...field
				  }
		})

		const propsTable: ITableWithSelectionFields = {
			tableFields: tableFields,
			fields: data,
			disableForm: true,
			selected: selectedRows,
			setSelection: handleSelection,
			handleChangeTable: handleChangeTable,
			label: 'Ejemplo',
			keyfield: 'niclie',
			checkBox: true,
			hideHeaderButtons: true,
			buttons: [
				{
					label: 'Edit',
					action: handleOpen,
					icon: faPen,
					color: '#007BFF',
					title: 'global.edit'
				}
			],
			paginationOption: fields && {
				page_size: fields.page_size,
				page_number: fields.page_number,
				total_count: fields.total_count
			},
			hideScrollX: true,
			hideScrollY: true
		}

		const propsModal = {
			itemInfo: editData,
			fields: editableModalFields,
			handleSubmit: handleModalSubmit,
			handleCloseEditPopup: handleCloseEditPopup,
			showEditPopup: showEditPopup,
			handleSelection: handleSelection,
			attribute0:
				customerAttrEdit?.lista[0]?.valores.length > 0
					? {
							lista: [...customerAttrEdit?.lista[0]?.valores]
					  }
					: {
							lista: []
					  },
			attribute1:
				customerAttrEdit?.lista[1]?.valores.length > 0
					? {
							lista: [...customerAttrEdit?.lista[1]?.valores]
					  }
					: {
							lista: []
					  },
			attribute2:
				customerAttrEdit?.lista[2]?.valores.length > 0
					? {
							lista: [...customerAttrEdit?.lista[2]?.valores]
					  }
					: {
							lista: []
					  },
			attribute3:
				customerAttrEdit?.lista[3]?.valores.length > 0
					? {
							lista: [...customerAttrEdit?.lista[3]?.valores]
					  }
					: {
							lista: []
					  },
			attribute4:
				customerAttrEdit?.lista[4]?.valores.length > 0
					? {
							lista: [...customerAttrEdit?.lista[4]?.valores]
					  }
					: {
							lista: []
					  },
			customerAttributesGlobalUploadModalFields: newFieldsConfig
		}
		const propsEditModal = {
			showModal: showEditPopup,
			handleCloseModal: handleCloseEditPopup,
			modalTitle: t('CRUDS.modal.title_edit'),
			modalBody: <CustomerAttributesGlobalModalForm {...propsModal} />,
			buttons: false,
			handleSubmit: handleModalSubmit,
			sizeModal: 'xl'
		}

		return (
			<Col>
				<Alert variant={'dark'}>
					<b>{t('CRUDS.general_use.attr_list')}</b>
				</Alert>
				{data.length > 0 && <TableWithSelection {...propsTable} />}
				{customerAttrEdit && <CommonModal {...propsEditModal} />}
			</Col>
		)
	}
}

const mapStateToProps = ({ customerAttrGlobalUpload }: any) => {
	const { customerAttrEdit } = customerAttrGlobalUpload
	return {
		customerAttrEdit
	}
}

const connectForm = connect(mapStateToProps, {
	customerAttrGlobalAssignEdit
})(CustomerAttributesGlobalUploadTable)

export default withTranslation()(connectForm)
